export default __webpack_public_path__ + "media/Crucible_right.485206c20238a6c84ea37434a4566cab.svg";